import React from 'react';
import GrayTag from './_base/GrayTag';

export default function CreatorTag(props) {
  return (
    <GrayTag label="CREATED BY YOU" />
  );
}
